import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/messages';
import { Container } from 'containers/common/LegalProceedings/styled-components';

export interface ValidatorRecapProps {
  intl: IntlShape;
  validator: String;
  customTitle?: string;
}

export const ValidatorRecap: React.FC<ValidatorRecapProps> = (
  props,
): JSX.Element => {
  return (
    <Container>
      <section className="section">
        <article>
          <h4 className="validator-recap-container-title">
            {props.customTitle
              ? props.customTitle
              : translate(messages.validator, props)}
          </h4>
        </article>
        <article className="item-validator">{props.validator}</article>
      </section>
    </Container>
  );
};

export default injectIntl(ValidatorRecap);
